import React from "react";
import ForgottenUserData from "../../ForgottenUserData";
import { activationLink } from "../../../../../../axios/api/services";

const ActivationLink = () => {
  return (
    <ForgottenUserData
      captchaAction={"PortalActivationLinkSubmit"}
      serviceFn={activationLink}
      successMessage={"m.activation.link.email.success"}
      pageTitle={"t.page.activation.link"}
      submitMessage={"l.btn.submit"}
    />
  );
};
export default ActivationLink;
